import { isDarkMode } from '@bubble-ui/particle-design-versions';
// TODO: We using a getDefaultStyleSheet to actually generate
// all the props of the svg path element, not only the style
export var getDefaultStyleSheet = _ref => {
  var {
    designVersion,
    inverse,
    gray
  } = _ref;
  return {
    rootStyle: {
      fill: gray ?
      // Hard coded values, because the logo colors should not depend on a design version
      isDarkMode(designVersion) ? '#787573' : '#969391' : inverse ? isDarkMode(designVersion) ? '#17120F' : '#FFFFFF' : isDarkMode(designVersion) ? '#FFFFFF' : '#17120F'
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map